/**
 * Input Type Constants
 */

export interface IInputTypeOption {
  label: string;
  value: number;
}

export const ALL_INPUT_TYPES: IInputTypeOption[] = [
  { label: "Text Input", value: 1 },
  { label: "Number Input", value: 2 },
  { label: "Yes/No (Boolean)", value: 3 },
  { label: "Multi Select (Checkboxes)", value: 4 },
  { label: "Single Select (Dropdown)", value: 5 },
  // { label: "Single Select with Images", value: 6 },
  // { label: "Colour Swatch Selector", value: 7 },
  // { label: "Visual Selector", value: 8 },
  // { label: "Colour Picker", value: 9 },
];
